export default {"src":"/_next/static/media/illnesses.e19da7f4.svg","height":86,"width":56};